<template>
  <div class="comp-attention">
    <div class="left-dir position-relative md-el-aside" v-resize-width id="attention-tree">
      <tree-list
        v-for="item in TreeArr"
        :key="item.categoryType"
        :ref="item.categoryType"
        :categoryType="item.categoryType"
        @dirChanged="(data, node) => treeDirChange(data, node, item.categoryType)"
        :defaultExpandedKeys="expandedType == item.categoryType && expandedTreeId ? [expandedTreeId] : []"
        :defaultNode="item.defaultNode"
      ></tree-list>
      
      <div style="flex: 1;cursor: auto;"></div>

      <div class="editbtn-view">
        <!-- <el-button size="medium" type="primary" @click="exportStep">导入模型</el-button> -->
        <!-- <el-button size="medium" type="primary" class="att-rec-btn1 att-rec-btn" @click="compRecommOpen">
          <span class="att-rec-btn2">我要推荐供应商</span>
        </el-button> -->
        <div style="cursor: pointer;text-align: center;">
          <img src="https://prodimg.global-dsc.cn/dgzz_img/xuanchuan/48efa0cca53ec5f213c658e5958a5e77.png" class="att-rec-btn" style="height: 70px;"  @click="compRecommOpen"/>
        </div>
      </div>
    </div>
    <attention ref="attentionRef"></attention>

    <div class="com-recommd">
      <attention-recommd labelPosition="top" :recommdTip="recommdTip" @recommdTipChange="recommdTipChange"></attention-recommd>
    </div>

  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
import {WinForm,CheckLibs} from '@digital-supply-chain/module'
import {UtilService} from '@/libs'
import {UserService,OpenService} from '@/service'

import {AutoCreateLectoDir, TreeArrData} from './defaultData'

import TreeList from '@/components/dir-tree/tree-list.vue';
import AttentionRecommd from "./attention-recommd.vue";
import Attention from './attention.vue';

const isClient = CheckLibs.isClient();
// 默认展开供应链还是零配件
const expanded = isClient ? WinForm.storge.get(`$attention_expanded_dir_${UserService.userID()}`) : sessionStorage.getItem(`$attention_expanded_dir_${UserService.userID()}`);
let expandSplit = [];
try {
  expandSplit = expanded ? expanded.split(',') : [];
} catch (error) {}
const [expandedType = 'EnterpriseDir', expandedTreeId = 'list_0'] = expandSplit;

export default {
  data() {
    return {
      expandedType,
      expandedTreeId,
      TreeArr: [],
      recommdTip: false,
      isClient,
    }
  },
  components: { TreeList, AttentionRecommd, Attention },
  mounted() {
    // 设置默认的零配件目录
    AutoCreateLectoDir();
    
    this.getTreeArr();
  },
  methods: {
    async getTreeArr() {
      const res = await UserService.isOrderMember();
      this.TreeArr = TreeArrData(res.data || false);
      this.$nextTick(() => {
        this.getDefaultCurrent();
      })
    },

    // 默认打开哪个顶级目录
    getDefaultCurrent() {
      try {
        this.$refs[this.expandedType][0].select(this.expandedTreeId);
      } catch (error) {}
    },

    // 设置下次用户进来后默认展开供应商还是零配件
    setDefaultCurrent(categoryType, treeId) {
      if (!isClient) {
        sessionStorage.setItem(`$attention_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
        return;
      }
      WinForm.storge.set(`$attention_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
    },

    treeDirChange(data, node, categoryType) {
      // 设置其他树所有不选中
      this.TreeArr.filter(item => item.categoryType != categoryType).forEach(item => {
        this.$refs[item.categoryType][0].setCurrentNull();
      })
      this.dirChanged(data, node, categoryType);
    },
    dirChanged(data, node, categoryType) {
      if (!categoryType) return;
      // === 当前节点的所有父节点数组 ===
      let parents=[node.data];
      let obj = node;
      while (obj.parent.data && obj.parent.data.DirName){
          parents.push(obj.parent.data);
          obj = obj.parent;
      }
      this.$refs.attentionRef.dirChanged(data.DirID || 0, parents, categoryType);
      this.compRecommClose();
      this.setDefaultCurrent(categoryType, parents[0].TreeID);
    },

    // 我要推荐供应商打开、关闭
    recommdTipChange(bool = undefined) {
			this.recommdTip = bool== undefined ? !this.recommdTip : bool;
		},
    compRecommOpen() {
      this.recommdTipChange(true)
    },
    compRecommClose() {
      this.recommdTipChange(false)
    },

    // 重新计算树DataCount
    dragDataCallback(toId, toDirCategoryId, fromId, fromDirCategoryId, copy = false) {
      // 原始目录的count计算
      let orginData = { toId, fromId };
      const toCategoryType = this.TreeArr.find(item => item.categoryId == toDirCategoryId).categoryType;
      const fromCategoryType = this.TreeArr.find(item => item.categoryId == fromDirCategoryId).categoryType;
      if (copy) {
        delete orginData.fromId;
        this.$refs[toCategoryType][0].dragDataCallback({ toId })
      }
      if (orginData.fromId == 0) {
        this.$refs[toCategoryType][0].dragDataCallback(orginData)
      } else {
        this.$refs[fromCategoryType][0].dragDataCallback(orginData)
      }
    },

    // 导入模型
    exportStep() {
      const appName = (WinForm.md.getAppNameLabel() || '大工程师').replace('企业版','');
      MessageBox.prompt(`请输入手机端小程序“${appName}”产品选型生成的模型序列号`, '导入模型', {
        width: 150,
        confirmButtonText: '确定导入',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          return (value.includes('be') || value.includes('?lecto_value_key='));
        },
        inputErrorMessage: '无效的序列号',
      }).then(async ({ value }) => {
        let value_key = value;

        const { lecto_value_key } = UtilService.getUrlParamObj(value);
        lecto_value_key && (value_key = lecto_value_key);

        const res = await UserService.getData(value_key);
        if (!res.data) {
          Message.info('模型链接已失效');
          return false;
        }
        OpenService.openProdDetails(JSON.parse(res.data).prodId, '', value_key);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.editbtn-view{
  padding: 10px;
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  border-top: 1px solid @line-strong-color;
  /deep/ .el-button{
    width: 100%;
    margin: 0;
  }
  .att-rec-btn1{
    margin-top: 10px;
    background: rgba(255, 0, 0, 0.6);
    border: 1px solid rgba(255,0,0,0.6);
    &:hover{
      background: rgba(255, 0, 0, 0.8);
      border: 1px solid rgba(255,0,0,0.8);
    }
  }
  .att-rec-btn2{
    margin-top: 10px;
  }
}
.recommn-btn{
    font-size: 15px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #F2F2F2;
    color: #ffffff;
    cursor: pointer;
    background-color: #409EFF;
}
.left-dir{
  height: calc(100vh - 20px);
  overflow-y: auto;
  border-right: 6px solid #F2F2F2;
  max-width: 500px;
  min-width: 230px;
  cursor: ew-resize;
  display: flex;
  flex-direction: column;
  /deep/ .tree-span[data-id = "0"] {
    font-weight: bold;
    color: #606266;
  }
  /deep/ .tree-span[data-id = "-1"] {
    font-weight: bold;
    color: #606266;
  }
}
.comp-recommen{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
}
.com-recommd{
  /deep/ .recommd-comp{
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    background-color: #ffffff;
    z-index: 100;
    /deep/ & > div{
      height: 100%;
    }
  }
}
.comp-attention{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }
}
</style>
